/* Moteur de prix des kits Test-Or : partagé par le composeur sur mesure (navigateur) et l'assistant (serveur).
   Entrée : la liste brute des produits (handle, titre, url, image, variantes [{ id, titre, prix, dispo }]) et la
   configuration (rôle de chaque handle). Sortie : le prix à la carte d'une sélection, le meilleur pack équivalent et
   le pack supérieur qui apporte plus qu'il ne coûte. Que des prix réels du catalogue : aucune remise inventée.
   9 oct. 2026 (Claude Code pour Raphaël) : kitPour() renvoie, pour toute sélection, le kit avec pierre déjà confectionné
   (variante volume + pierre, balance et loupe incluses ou à ajouter). Les kits se lisent aussi dans les produits
   (champs facultatifs type, reactifs, inclus, photo, image de variante exportés par snippets/to-donnees-produit) :
   config.packs n'est plus obligatoire. evaluer() garde son contrat (l'assistant l'utilise).
   Balance avec un kit (soir du 9 oct.) : la remise automatique « Balance à 13,99 € avec votre kit » (une balance par
   commande) est annoncée par config.prixBalanceKit (réglage du thème prix_balance_avec_kit) et par le champ balanceKit des
   produits qui y donnent droit (snippets/to-balance-kit). kitPour() compte alors la balance ajoutée à part à ce prix, et
   garde son prix habituel (prixHabituel) pour le prix barré. evaluer() et aLaCarte() n'en tiennent pas compte : sans kit
   dans le panier, la balance reste à son prix.
   10 oct. 2026 (Raphaël : « une option avec ou sans coffret en bois ») : config.coffret, le produit option « coffret en bois »
   (une variante par volume de flacons : 22 € en 5 ml, 25 € en 15 ml, lus dans ses prix de variante). kitPour() l'ajoute
   au kit quand choix.coffret est vrai : ligne juste après le kit (le panier reçoit kit, coffret, puis accessoires), total et
   sélection à la carte comptés avec lui (l'économie ne change pas : le coffret coûte le même prix des deux côtés). Un
   coffret complet (produit coffret) n'est plus proposé à côté que s'il inclut un accessoire (Coffret Expert, coffret avec
   balance et loupe), ou s'il coûte moins cher que le kit avec l'option : sinon l'option fait la même chose au même prix.
   evaluer() et aLaCarte() sont inchangés. */
(function (racine, fabrique) {
  if (typeof module === "object" && module.exports) module.exports = fabrique();
  else racine.TestOrMoteur = fabrique();
})(typeof self !== "undefined" ? self : this, function () {
  var ORDRE = ["9k", "14k", "18k", "24k", "ag", "pt"];
  var NOMS = { "9k": "9K", "14k": "14K", "18k": "18K", "24k": "24K", ag: "argent", pt: "platine" };

  var cle = function (codes) { return ORDRE.filter(function (c) { return codes.indexOf(c) >= 0; }).join("-"); };
  var arrondi = function (x) { return Math.round(x * 100) / 100; };
  /* v : variante brute. contenu (facultatif) : ce que le produit contient quel que soit le choix (voir contenuDe) ;
     il ne sert que si le titre de la variante n'en dit rien (« Default Title », « 5 ml » d'un coffret…). */
  var lireVariante = function (v, contenu) {
    var t = v.titre || "", k = contenu || {};
    return {
      id: v.id, titre: t, prix: Number(v.prix), dispo: v.dispo !== false,
      vol: /15\s?ml/i.test(t) ? 15 : (/\d\s?ml\b/i.test(t) ? 5 : (k.vol || 5)),
      pierre: /150\s?[x×]\s?50/i.test(t) ? 150 : (/62\s?[x×]\s?38/i.test(t) ? 62 : (k.pierre || 0)),
      balance: /avec balance/i.test(t) || (!/sans balance/i.test(t) && !!k.balance),
      loupe: /avec loupe/i.test(t) || (!/sans loupe/i.test(t) && !!k.loupe),
      coffret: !!k.coffret,
      image: v.image || null
    };
  };

  // Codes réactifs exportés par le thème (métachamp custom.reactifs, sinon table et heuristiques de to-profil).
  var codesDe = function (p) {
    var r = p.reactifs;
    if (typeof r === "string") r = r.split(/[,;\s]+/);
    if (!r || !r.length) return null;
    var vus = {};
    r.forEach(function (x) {
      x = String(x).toLowerCase().trim();
      var c = { "9": "9k", "14": "14k", "18": "18k", "24": "24k", "20-24k": "24k", argent: "ag", platine: "pt" }[x] || x;
      if (ORDRE.indexOf(c) >= 0) vus[c] = true;
    });
    var codes = ORDRE.filter(function (c) { return vus[c]; });
    return codes.length ? codes : null;
  };
  /* Contenu fixe d'un kit, d'un coffret ou d'un pack : métachamp custom.inclus (« pierre,balance,loupe,coffret ») s'il
     est exporté, sinon le type, le titre et le handle. vol : contenance d'un produit à variante unique (« 15 ml »). */
  var contenuDe = function (p) {
    var t = String((p.titre || "") + " " + (p.handle || "")).toLowerCase();
    var k = { vol: /15[\s-]?ml/.test(t) ? 15 : 0, pierre: 0, balance: false, loupe: false, coffret: false };
    var grande = /grande[\s-]pierre|150\s?[x×]\s?50/.test(t);
    var inc = p.inclus;
    if (inc && typeof inc !== "string") inc = inc.join(",");
    if (inc) {
      inc = String(inc).toLowerCase();
      if (/pierre/.test(inc)) k.pierre = grande || /grande|150/.test(inc) ? 150 : 62;
      k.balance = /balance/.test(inc);
      k.loupe = /loupe/.test(inc);
      k.coffret = /coffret/.test(inc);
    } else {
      k.coffret = p.type ? p.type === "coffret" : /coffret/.test(t);
      var sansPierre = p.type === "reactif" || p.type === "accessoire" || /sans pierre/.test(t);
      if (!sansPierre && (p.type === "kit" || k.coffret || /pierre/.test(t))) k.pierre = grande ? 150 : 62;
      k.balance = /balance/.test(t) && !/sans balance/.test(t);
      k.loupe = /loupe/.test(t) && !/sans loupe/.test(t);
    }
    return k;
  };

  /* produits : [{ handle, titre, url, image, variantes, [type, reactifs, inclus, photo, balanceKit] }] ;
     config : { reactifs: { code: handle }, pierre, balance, loupe, [packs: { handle: [codes] }], [prixBalanceKit], [coffret] }.
     coffret : handle du produit option « coffret en bois » (variantes « Pour flacons 5 ml », « Pour flacons 15 ml »).
     Packs : ceux de config.packs, puis tout produit exporté avec ses codes (kit, coffret ou pack de plusieurs flacons). */
  function catalogue(produits, config) {
    var parHandle = {};
    produits.forEach(function (p) { parHandle[p.handle] = p; });
    var simple = function (h, avecContenu) {
      var p = parHandle[h];
      if (!p) return null;
      var k = avecContenu ? contenuDe(p) : null;
      var v = p.variantes.map(function (x) { return lireVariante(x, k); });
      return { handle: h, titre: p.titre, url: p.url, image: p.image, photo: p.photo || null, variantes: v };
    };
    var cat = { reactifs: {}, pierre: simple(config.pierre), balance: simple(config.balance), loupe: simple(config.loupe), packs: [],
                optionCoffret: config.coffret ? simple(config.coffret) : null };
    Object.keys(config.reactifs).forEach(function (c) { var s = simple(config.reactifs[c]); if (s) cat.reactifs[c] = s; });
    var base = {}, vus = {};
    Object.keys(config.reactifs).forEach(function (c) { base[config.reactifs[c]] = true; });
    [config.pierre, config.balance, config.loupe, config.coffret].forEach(function (h) { if (h) base[h] = true; });
    var ajouter = function (h, codes) {
      if (vus[h] || base[h] || !codes || !codes.length) return;
      var s = simple(h, true);
      if (!s) return;
      vus[h] = true;
      s.codes = codes;
      s.balanceOption = s.variantes.some(function (v) { return v.balance; });
      s.coffret = s.variantes.some(function (v) { return v.coffret; });
      s.avecPierre = s.variantes.some(function (v) { return v.pierre > 0; });
      s.balanceKit = !!parHandle[h].balanceKit; // donne droit à la balance au prix avec un kit
      cat.packs.push(s);
    };
    var packs = config.packs || {};
    Object.keys(packs).forEach(function (h) { ajouter(h, (parHandle[h] && codesDe(parHandle[h])) || packs[h]); });
    produits.forEach(function (p) {
      var codes = codesDe(p);
      if (!codes || p.type === "accessoire" || (p.type === "reactif" && codes.length < 2)) return;
      ajouter(p.handle, codes);
    });
    // Prix de la balance avec un kit : retenu seulement s'il est inférieur au prix de la balance seule
    var vb = unique(cat.balance), pbk = Number(config.prixBalanceKit);
    cat.prixBalanceKit = vb && pbk > 0 && pbk < vb.prix - 0.005 ? arrondi(pbk) : null;
    return cat;
  }

  var variante = function (produit, filtre) {
    if (!produit) return null;
    return produit.variantes.filter(function (v) { return v.dispo && filtre(v); })[0] || null;
  };
  var prixReactif = function (cat, code, vol) {
    var v = variante(cat.reactifs[code], function (x) { return x.vol === vol; });
    return v ? v.prix : null;
  };
  var prixPierre = function (cat, taille) {
    var v = variante(cat.pierre, function (x) { return x.pierre === taille || (taille === 62 && x.pierre === 0 && /62/.test(x.titre)); });
    return v ? v.prix : null;
  };
  var unique = function (p) { var v = variante(p, function () { return true; }); return v; };

  /* choix : { codes: [], vol: 5|15, pierre: 0|62|150, balance: bool, loupe: bool } */
  function aLaCarte(cat, choix) {
    var lignes = [], manque = [];
    choix.codes.forEach(function (c) {
      var p = cat.reactifs[c], v = variante(p, function (x) { return x.vol === choix.vol; });
      if (v) lignes.push({ id: v.id, titre: p.titre + " · " + choix.vol + " ml", prix: v.prix, handle: p.handle });
      else manque.push(NOMS[c]);
    });
    if (choix.pierre) {
      var vp = variante(cat.pierre, function (x) { return x.pierre === choix.pierre || new RegExp(String(choix.pierre)).test(x.titre); });
      if (vp) lignes.push({ id: vp.id, titre: cat.pierre.titre + " · " + vp.titre, prix: vp.prix, handle: cat.pierre.handle });
    }
    [["balance", choix.balance], ["loupe", choix.loupe]].forEach(function (a) {
      if (!a[1]) return;
      var v = unique(cat[a[0]]);
      if (v) lignes.push({ id: v.id, titre: cat[a[0]].titre, prix: v.prix, handle: cat[a[0]].handle });
    });
    return { lignes: lignes, total: arrondi(lignes.reduce(function (s, l) { return s + l.prix; }, 0)), manque: manque };
  }

  function evaluer(cat, choix) {
    var carte = aLaCarte(cat, choix);
    var res = { cle: cle(choix.codes), carte: carte, meilleure: { type: "carte", total: carte.total, lignes: carte.lignes }, equivalent: null, superieur: null };
    if (!choix.codes.length) return res;
    var pierreChoisie = choix.pierre ? prixPierre(cat, choix.pierre) || 0 : 0;
    var balanceSeule = cat.balance ? (unique(cat.balance) || {}).prix || 0 : 0;
    var loupeSeule = cat.loupe ? (unique(cat.loupe) || {}).prix || 0 : 0;
    var candidats = [];
    cat.packs.forEach(function (p) {
      if (p.coffret) return; // coffrets : proposés par kitPour() seulement (evaluer() garde son périmètre d'avant)
      if (!choix.codes.every(function (c) { return p.codes.indexOf(c) >= 0; })) return;
      var ajout = p.codes.filter(function (c) { return choix.codes.indexOf(c) < 0; });
      var valeurAjout = 0, ok = true;
      ajout.forEach(function (c) { var x = prixReactif(cat, c, choix.vol); if (x === null) ok = false; else valeurAjout += x; });
      if (!ok) return;
      p.variantes.forEach(function (v) {
        if (!v.dispo || v.vol !== choix.vol) return;
        if (choix.pierre && v.pierre !== choix.pierre) return;
        if (p.balanceOption && choix.balance && !v.balance) return;
        var lignes = [{ id: v.id, titre: p.titre + " · " + v.titre, prix: v.prix, handle: p.handle }];
        var total = v.prix, bonus = valeurAjout, cadeaux = ajout.map(function (c) { return NOMS[c]; });
        if (!choix.pierre && v.pierre) { bonus += prixPierre(cat, v.pierre) || 0; cadeaux.push(v.pierre === 150 ? "la grande pierre 150 × 50 mm" : "la pierre 62 × 38 mm"); }
        if (v.balance && !choix.balance) { bonus += balanceSeule; cadeaux.push("la balance 0,01 g"); }
        if (choix.balance && !v.balance) { var vb = unique(cat.balance); if (vb) { lignes.push({ id: vb.id, titre: cat.balance.titre, prix: vb.prix, handle: cat.balance.handle }); total += vb.prix; } }
        if (v.loupe && !choix.loupe) { bonus += loupeSeule; cadeaux.push("la loupe éclairée"); }
        if (choix.loupe && !v.loupe) { var vl = unique(cat.loupe); if (vl) { lignes.push({ id: vl.id, titre: cat.loupe.titre, prix: vl.prix, handle: cat.loupe.handle }); total += vl.prix; } }
        candidats.push({ type: "pack", handle: p.handle, titre: p.titre, url: p.url, image: p.image, variante: v, codes: p.codes, cle: cle(p.codes),
                         lignes: lignes, total: arrondi(total), bonus: arrondi(bonus), ajouts: cadeaux, exact: !cadeaux.length });
      });
    });
    // Pack équivalent : même contenu que la sélection, moins cher que les articles séparés.
    var exacts = candidats.filter(function (c) { return c.exact && c.total < carte.total - 0.005; }).sort(function (a, b) { return a.total - b.total; });
    if (exacts.length) {
      var e = exacts[0];
      e.economie = arrondi(carte.total - e.total);
      res.equivalent = e;
      res.meilleure = e;
    }
    var base = res.meilleure.total;
    // Pack supérieur : il ajoute plus de valeur (au prix des articles séparés) qu'il ne coûte en plus.
    var sup = candidats.filter(function (c) { return !c.exact; }).map(function (c) {
      c.surcout = arrondi(c.total - base);
      c.gain = arrondi(c.bonus - c.surcout);
      return c;
    }).filter(function (c) { return c.gain > 0.5 && c.surcout <= Math.max(18, base * 0.75); })
      .sort(function (a, b) { return ratio(b) - ratio(a) || a.surcout - b.surcout; });
    if (sup.length) res.superieur = sup[0];
    return res;
  }
  // Valeur offerte par euro ajouté : le pack supérieur le plus rentable pour le client.
  function ratio(c) { return c.gain / Math.max(c.surcout, 1); }

  /* ------------------------------------------------------------------ Kit sur mesure (9 oct. 2026)
     kitPour(cat, choix, [options]) : le kit déjà confectionné qui correspond à la sélection, pierre toujours comprise.
     choix : { codes, vol: 5|15, pierre: 62|150 (0 ou absent : 62), balance, loupe }.
     Ordre de préférence : mêmes réactifs exactement (sinon le kit le plus proche qui les contient tous), aucun
     accessoire imposé en plus, le moins d'accessoires à ajouter à part (un kit qui inclut balance et loupe passe
     devant le kit + accessoires), puis le prix. Les coffrets ne sont jamais le choix principal : ils sont proposés à côté
     (« coffret ») quand ils ont les mêmes réactifs et couvrent les accessoires demandés.
     Plus complet et moins cher (relecture du 9 oct.) : un kit qui contient tous les réactifs du kit retenu et d'autres en
     plus, sans accessoire imposé, et qui coûte moins cher ou autant (accessoires à part compris), devient le choix
     principal. Exemple (balance à 19,90 €) : 14K 18K 24K + balance + loupe → Kit Expert à 59,90 € plutôt que kit 3 réactifs
     + balance + loupe à 65,50 €. Avec la balance à 13,99 € avec un kit, ce kit exact revient à 59,59 € : il redevient le
     choix principal, et le Kit Expert passe en kit supérieur (+0,31 € pour le 9K). Jamais d'upsell à surcoût nul ou
     négatif : ces cas passent par là.
     Sortie : null sans réactif ; sinon { cle, choix, kit, exact, ajouts, accessoires, imposes, indisponibles, lignes, total,
     url, carte, economie, coffret, superieur, plusComplet } (kit null si aucun kit ne convient : repli sur la sélection
     à la carte). imposes : accessoires non demandés que le kit inclut d'office (version sans épuisée). plusComplet :
     { ajouts, economie, exact: { kit, total, url, accessoires, optionCoffret } } quand le choix principal est un kit plus complet.
     accessoires et lignes : la balance ajoutée à un kit qui donne droit à la remise porte prix (avec le kit) et
     prixHabituel (seule) ; total et economie comptent le prix avec le kit.
     options.superieur === false : sans la recherche du kit supérieur (prix affichés sur les cases).
     Coffret en bois (10 oct.) : choix.coffret ; optionCoffret : la ligne du coffret ajoutée au kit (variante du volume
     choisi), ou null ; indisponibles contient « coffret » s'il n'est pas disponible dans ce volume. lignes : kit, coffret,
     puis accessoires ; total, carte et kit supérieur le comptent. coffret (proposé à côté) : voir garderCoffret. */
  var normaliser = function (choix) {
    return { codes: ORDRE.filter(function (c) { return (choix.codes || []).indexOf(c) >= 0; }), vol: Number(choix.vol) === 15 ? 15 : 5,
             pierre: Number(choix.pierre) === 150 ? 150 : 62, balance: !!choix.balance, loupe: !!choix.loupe, coffret: !!choix.coffret };
  };
  var lienVariante = function (url, id, params) {
    var u = url + (url.indexOf("?") < 0 ? "?" : "&") + "variant=" + id;
    (params || []).forEach(function (p) { u += "&" + p + "=1"; });
    return u;
  };
  /* Accessoire ajouté à part au kit k. Balance avec un kit qui y donne droit : son prix avec le kit (remise automatique, une
     balance par commande : kitPour n'en ajoute jamais qu'une), et prixHabituel, son prix seule, pour le prix barré. */
  var ligneAccessoire = function (cat, role, k) {
    var p = cat[role], v = unique(p);
    if (!v) return null;
    var l = { role: role, id: v.id, titre: p.titre, prix: v.prix, handle: p.handle, url: p.url };
    if (role === "balance" && k && k.balanceKit && cat.prixBalanceKit) { l.prix = cat.prixBalanceKit; l.prixHabituel = v.prix; }
    return l;
  };
  // Coffret en bois en option : la variante au volume des flacons du kit (« Pour flacons 15 ml »), ou null.
  var ligneCoffret = function (cat, vol) {
    var p = cat.optionCoffret, v = variante(p, function (x) { return x.vol === vol; });
    return v ? { role: "coffret", id: v.id, titre: p.titre + " · " + v.titre, prix: v.prix, handle: p.handle, url: p.url } : null;
  };
  var candidatsKit = function (cat, c) {
    var liste = [];
    cat.packs.forEach(function (p, rang) {
      if (!p.avecPierre) return; // les kits ont toujours leur pierre : jamais de pack de flacons seuls
      if (!c.codes.every(function (x) { return p.codes.indexOf(x) >= 0; })) return;
      var extra = p.codes.filter(function (x) { return c.codes.indexOf(x) < 0; });
      p.variantes.forEach(function (v) {
        if (!v.dispo || v.vol !== c.vol || v.pierre !== c.pierre) return;
        var aPart = [], trop = [], manque = [];
        [["balance", c.balance, v.balance], ["loupe", c.loupe, v.loupe]].forEach(function (a) {
          if (a[1] && !a[2]) { var l = ligneAccessoire(cat, a[0], p); if (l) aPart.push(l); else manque.push(a[0]); }
          if (!a[1] && a[2]) trop.push(a[0]);
        });
        // Coffret en bois demandé : ajouté aux kits en pochette (un coffret complet l'inclut déjà)
        var lc = null;
        if (c.coffret && !p.coffret && !v.coffret) { lc = ligneCoffret(cat, c.vol); if (!lc) manque.push("coffret"); }
        liste.push({ p: p, v: v, rang: rang, extra: extra, aPart: aPart, trop: trop, manque: manque, coffretLigne: lc,
                     total: arrondi(v.prix + (lc ? lc.prix : 0) + aPart.reduce(function (s, l) { return s + l.prix; }, 0)) });
      });
    });
    return liste;
  };
  var trier = function (a, b) {
    return a.extra.length - b.extra.length || a.trop.length - b.trop.length || a.aPart.length - b.aPart.length ||
           a.total - b.total || a.rang - b.rang;
  };
  var decrire = function (x) {
    var p = x.p, v = x.v;
    return { handle: p.handle, titre: p.titre, url: p.url, codes: p.codes, cle: cle(p.codes), coffret: !!p.coffret,
             image: v.image || p.photo || p.image || null, photo: v.image || p.photo || null, variante: v,
             inclus: { pierre: v.pierre, balance: v.balance, loupe: v.loupe, coffret: v.coffret },
             lien: lienVariante(p.url, v.id, x.aPart.map(function (l) { return l.role; })), total: x.total };
  };
  // Le résultat prend le candidat m comme choix principal (kit, lignes du panier, total, lien, économie).
  var remplir = function (res, m) {
    res.kit = decrire(m);
    res.exact = !m.extra.length;
    res.ajouts = m.extra.map(function (x) { return NOMS[x]; });
    res.accessoires = m.aPart;
    res.imposes = m.trop.slice();
    res.indisponibles = m.manque;
    res.optionCoffret = m.coffretLigne || null;
    var lc = m.coffretLigne ? [{ id: m.coffretLigne.id, titre: m.coffretLigne.titre, prix: m.coffretLigne.prix, handle: m.coffretLigne.handle, role: "coffret" }] : [];
    res.lignes = [{ id: m.v.id, titre: m.p.titre + " · " + m.v.titre, prix: m.v.prix, handle: m.p.handle }].concat(lc, m.aPart.map(function (l) {
      var x = { id: l.id, titre: l.titre, prix: l.prix, handle: l.handle };
      if (l.prixHabituel) x.prixHabituel = l.prixHabituel;
      return x;
    }));
    res.total = m.total;
    res.url = res.kit.lien;
    res.economie = !res.carte.manque.length && res.carte.total > m.total + 0.005 ? arrondi(res.carte.total - m.total) : 0;
    return res;
  };
  function kitPourBase(cat, c, tous) {
    tous = tous || candidatsKit(cat, c);
    var kits = tous.filter(function (x) { return !x.p.coffret; }).sort(trier);
    var coffrets = tous.filter(function (x) { return x.p.coffret && !x.extra.length && !x.aPart.length; }).sort(trier);
    var carte = aLaCarte(cat, c);
    if (c.coffret) {
      // La sélection à la carte compte aussi le coffret demandé (même prix qu'avec le kit) : l'économie reste juste
      var lc = ligneCoffret(cat, c.vol);
      if (lc) carte = { lignes: carte.lignes.concat([{ id: lc.id, titre: lc.titre, prix: lc.prix, handle: lc.handle, role: "coffret" }]), total: arrondi(carte.total + lc.prix), manque: carte.manque };
    }
    var res = { cle: cle(c.codes), choix: c, kit: null, exact: false, ajouts: [], accessoires: [], imposes: [], indisponibles: [], lignes: carte.lignes,
                total: carte.total, url: null, carte: carte, economie: 0, coffret: coffrets.length ? decrire(coffrets[0]) : null, superieur: null,
                plusComplet: null, optionCoffret: null };
    return kits[0] ? remplir(res, kits[0]) : res;
  }
  // Kit plus complet (tous les réactifs du kit retenu, et d'autres) sans accessoire imposé, au total inférieur ou égal.
  var plusComplet = function (tous, res) {
    var base = res.kit;
    var mieux = tous.filter(function (x) {
      return !x.p.coffret && !x.trop.length && !x.manque.length && x.total <= res.total + 0.005 && x.p.codes.length > base.codes.length &&
             base.codes.every(function (k) { return x.p.codes.indexOf(k) >= 0; });
    }).sort(function (a, b) { return a.total - b.total || a.aPart.length - b.aPart.length || a.p.codes.length - b.p.codes.length || a.rang - b.rang; });
    if (!mieux.length) return false;
    var m = mieux[0], avant = { kit: base, total: res.total, url: res.url, accessoires: res.accessoires, exact: res.exact, optionCoffret: res.optionCoffret };
    remplir(res, m);
    res.plusComplet = { ajouts: m.p.codes.filter(function (k) { return base.codes.indexOf(k) < 0; }).map(function (k) { return NOMS[k]; }),
                        economie: arrondi(avant.total - m.total), exact: avant };
    return true;
  };
  /* Coffret complet proposé à côté (10 oct.) : avec l'option coffret en bois, un coffret qui ne contient que le kit (mêmes
     réactifs, même pierre) fait double emploi quand il coûte autant que le kit et l'option (59,90 € → 57 € = 35 + 22) : il
     n'est plus proposé. Restent proposés, comme avant : les coffrets qui incluent un accessoire (Coffret Expert, coffret
     avec balance et loupe), et un coffret moins cher que le kit avec l'option. Sans option disponible : comme avant. */
  var garderCoffret = function (cat, c, res) {
    var co = res.coffret, lc = co && res.kit ? ligneCoffret(cat, c.vol) : null;
    if (lc && !co.inclus.balance && !co.inclus.loupe && co.total >= res.total + (res.optionCoffret ? 0 : lc.prix) - 0.005) res.coffret = null;
    return res;
  };
  function kitPour(cat, choix, options) {
    var c = normaliser(choix);
    if (!c.codes.length) return null;
    var tous = candidatsKit(cat, c);
    var res = kitPourBase(cat, c, tous);
    if (res.kit && plusComplet(tous, res)) return garderCoffret(cat, c, res); // déjà le meilleur rapport contenu / prix : pas de kit supérieur
    garderCoffret(cat, c, res);
    if (!res.kit || !res.exact || (options && options.superieur === false)) return res;
    // Kit supérieur : le kit existant qui ajoute UN réactif, coûte plus (jamais de surcoût négatif) mais moins que ce
    // réactif au prix de la recharge.
    var vus = {}, sup = [];
    cat.packs.forEach(function (p) {
      if (!p.avecPierre || p.coffret || p.codes.length !== c.codes.length + 1) return;
      if (!c.codes.every(function (x) { return p.codes.indexOf(x) >= 0; })) return;
      var k = cle(p.codes);
      if (vus[k]) return;
      vus[k] = true;
      var r = kitPourBase(cat, { codes: p.codes, vol: c.vol, pierre: c.pierre, balance: c.balance, loupe: c.loupe, coffret: c.coffret });
      if (!r.kit || !r.exact || r.kit.coffret) return;
      var ajout = p.codes.filter(function (x) { return c.codes.indexOf(x) < 0; }), valeur = 0, ok = true;
      ajout.forEach(function (x) { var pr = prixReactif(cat, x, c.vol); if (pr === null) ok = false; else valeur += pr; });
      if (!ok) return;
      var surcout = arrondi(r.total - res.total), gain = arrondi(valeur - surcout);
      if (surcout > 0.005 && gain > 0.5 && surcout <= Math.max(18, res.total * 0.75)) {
        sup.push({ kit: r.kit, codes: r.kit.codes, total: r.total, url: r.url, surcout: surcout, bonus: arrondi(valeur), gain: gain,
                   ajouts: ajout.map(function (x) { return NOMS[x]; }) });
      }
    });
    sup.sort(function (a, b) { return ratio(b) - ratio(a) || a.surcout - b.surcout; });
    res.superieur = sup[0] || null;
    return res;
  }

  return { ORDRE: ORDRE, NOMS: NOMS, cle: cle, catalogue: catalogue, aLaCarte: aLaCarte, evaluer: evaluer, lireVariante: lireVariante,
           kitPour: kitPour, codesDe: codesDe, contenuDe: contenuDe };
});
